import modifyPassword from './modify-password.vue';

export default modifyPassword;
